import React, { useState } from 'react';
import '../SignUp/SignUp.scss';
import './ResetPassword.scss';
import eyeopen from "../../assets/icons/eye.svg";
import eyeclose from "../../assets/icons/eyeclosed.svg";
import passIcon from '../../assets/images/DashboardImages/icons/teenyicons_password-outline.svg';
import logo from '../../assets/images/DashboardImages/logo.svg';
import rightImg from '../../assets/images/DashboardImages/images/resetPassword.png';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ResetPassword = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [viewPassword, setViewPassword] = useState(false);
    const [hidePassword, setHidePassword] = useState(false);
    const [passwordError, setPasswordError] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        const isValid = validateInputs();
        if (!isValid) {
            toast.error(passwordError);
            return;
        }
    };

    const validateInputs = () => {
        setPasswordError('');

        if (password !== confirmPassword) {
            setPasswordError('Passwords do not match');
            toast.error('Passwords do not match');
        } else if (password.length < 6) {
            toast.error('Password must be at least 6 characters long');
        } else {
            return true;
        }
        return false;
    };

    return (
        <div>
            <img src={logo} alt='' className='logo-dash' />
            <form className='credentional-main-container' onSubmit={handleSubmit}>
                <div className='credentional-main-left-container'>
                    <div className='credentional-left-centered-container reset-left-centered-container'>
                        <h3>Password Reset</h3>
                        <p>Regain access to your account with a<br /> secure password reset</p>
                        <h5>Reset your password</h5>
                        <span>
                            <img src={passIcon} alt='' />
                            <input type={hidePassword ? 'text' :'password'}
                                placeholder='Password' value={password} onChange={(e) => setPassword(e.target.value)} />
                            {hidePassword ?
                                (<img src={eyeopen} onClick={() => setHidePassword(!hidePassword)} />) :
                                (<img src={eyeclose} onClick={() => setHidePassword(!hidePassword)} />)
                            }
                        </span>
                        <span>
                            <img src={passIcon} alt='' />
                            <input type={viewPassword ? 'text': 'password'} placeholder='Confirm Password' value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                            {viewPassword ? (
                                <img src={eyeopen}
                                    onClick={() => setViewPassword(!viewPassword)}
                                />
                            ) : (
                                <img src={eyeclose}
                                    onClick={() => setViewPassword(!viewPassword)} />
                            )}
                        </span>
                        {passwordError && <p className='error-message color-red'>{passwordError}</p>}
                        <button className='themebtn-1' type='submit'>Change Password</button>
                        <p><Link to="/login" className='login-Link'>Back to Login</Link></p>
                    </div>
                </div>
                <div className='credentional-main-right-container'>
                    <img src={rightImg} alt='' />
                </div>
            </form>
            <ToastContainer position="top-right" autoClose={3000} />
        </div>
    );
};

export default ResetPassword;
